module.exports = __webpack_public_path__ + "img/qr_bank_small.bbca9f00.png";